import { Box } from '@mui/material'

function TopBarError() {
    return (
        <Box flex={1} display='flex' flexDirection='row'>
            <Box
                width='var(--left-nav-width)'
                maxHeight='100%'
                p={1}
                display='flex'
                alignItems='center'>
                <img
                    src='https://nasco.com/wp-content/uploads/nasco-logo-blue.webp'
                    alt=''
                    style={{ width: '55%', aspectRatio: 441 / 88, objectFit: 'contain' }}
                />
            </Box>
        </Box>
    )
}

export default TopBarError
